import * as yup from 'yup';

const PostcodeValidationSchema = yup
  .string()
  .matches(/^[A-Za-z0-9 \-]{0,10}$/, { message: 'Invalid Post Code format' });

export default PostcodeValidationSchema;
